import * as React from "react";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { UpdateLifetimeAllowanceContent } from "../Resource/Content";
import { PercentageTextBoxEditor } from "../../../../../../react-core/Html/PercentageTextBoxEditor";
import { OffPlatformLifeTimeAllowance } from "../../../../../../Wrap/Models/Domains/Account/OffPlatformLifeTimeAllowance";
import { AccountLifeTimeAllowance } from "../../../../../../Wrap/Models/Domains/Account/AccountLifeTimeAllowance";
import { UpdateLifetimeAllowanceAction } from "../Actions/UpdateLifetimeAllowanceAction";
import AriaTooltip from "../../../../../../applications/Shared/Tooltip/AriaTooltip";
import { RadiosEditor } from "../../../../../../react-core/Html/RadiosEditor";
import { NumberTextBoxEditor } from "../../../../../../react-core/Html/NumberTextBoxEditor";
import { CurrencyCode } from "../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";

interface IUpdateLifetimeAllowanceDetailProps extends IProcessComponentProps {
    extraInfo: any;
}

interface IUpdateLifetimeAllowanceDetailPropsState {
    lifetimeAllowanceOffPlatform: number;
    hasLifetimeAllowanceOffPlatformChanged: boolean;
    isTYE2024Change: boolean;
}

export class UpdateLifetimeAllowanceDetail extends ProcessComponent<
    IUpdateLifetimeAllowanceDetailProps,
    IUpdateLifetimeAllowanceDetailPropsState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            lifetimeAllowanceOffPlatform: 0,
            hasLifetimeAllowanceOffPlatformChanged: false,
            isTYE2024Change: true,
        };
    }

    private getOnPlatformData(): AccountLifeTimeAllowance {
        return (
            this.props.extraInfo?.onPlatformData ?? {
                UsedOffPlatformAllowance: 0,
                UsedOnfPlatformAllowance: 0,
                UsedByBenefitsPrior472006: 0,
            }
        );
    }

    private getOffPlatformData(): OffPlatformLifeTimeAllowance {
        return (
            this.props.extraInfo?.offPlatformData ?? {
                LifeTimeAllowanceUsedPercentage: 0,
                BenefitCrystallisationEventTotals: [],
                PrimaryPclsUsages: [],
            }
        );
    }

    private GetLtaPreviouslyCrystallisedOnPlatform(): number {
        return this.getOnPlatformData().UsedOnfPlatformAllowance;
    }

    private GetLtaUsedByBenefitsThatCommencedPriorToDate(): number {
        return this.getOnPlatformData().UsedByBenefitsPrior472006;
    }

    private GetLtaUsed(): number {
        return (
            this.getOnPlatformData().UsedOnfPlatformAllowance +
            this.getOnPlatformData().UsedByBenefitsPrior472006 +
            (this.state.hasLifetimeAllowanceOffPlatformChanged ? this.state.lifetimeAllowanceOffPlatform : this.getOffPlatformData().LifeTimeAllowanceUsedPercentage
            )
        );
    }

    private GetAllowanceSum(): number {
        const onPlatform = this.props.extraInfo?.onPlatformData || {};
        const offPlatform = this.props.data?.offPlatformData || {};

        return (
            (onPlatform.UsedOnPlatformLumpSumAllowancePre2024 ?? 0) +
            (onPlatform.UsedOnPlatformLumpSumAllowancePost2024 ?? 0) +
            (onPlatform.UsedOnPlatformLumpSumAllowancePreADay ?? 0) +
            (onPlatform.UsedOnPlatformLumpSumDeathBenefitsAllowancePre2024 ?? 0) +
            (onPlatform.UsedOnPlatformLumpSumDeathBenefitsAllowancePost2024 ?? 0) +
            (onPlatform.UsedOnPlatformLumpSumDeathBenefitsAllowancePreADay ?? 0) +
            (offPlatform.otherUsedAsAt5April2024Amount ?? 0) +
            (offPlatform.otherUsedOnOrAfter6April2024Amount ?? 0) +
            (offPlatform.otherLSDBAUsedAsAt5April2024Amount ?? 0) +
            (offPlatform.otherLSDBAUsedOnOrAfter6April2024Amount ?? 0)
        );
    }

    public GetOffPlatformLifeTimeAllowance(): number {
        return this.getOnPlatformData().UsedOffPlatformAllowance;
    }

    render() {
        const { isTYE2024Change } = this.state;
        const { extraInfo, onChange, data } = this.props;
        return (
            <>
                {isTYE2024Change &&
                    <>
                        <h2>{UpdateLifetimeAllowanceContent.ltaDetails}</h2>
                        {UpdateLifetimeAllowanceContent.lsaUsedAsAt5April2024Amount}
                        <td className="cell-right">£{extraInfo?.onPlatformData?.UsedOnPlatformLumpSumAllowancePre2024}</td>
                        {UpdateLifetimeAllowanceContent.lsaUsedOnOrAfter6April2024Amount}
                        <td className="cell-right">£{extraInfo?.onPlatformData?.UsedOnPlatformLumpSumAllowancePost2024}</td>
                        {UpdateLifetimeAllowanceContent.lsaUsedBefore6April2006Amount}
                        <td className="cell-right">£{extraInfo?.onPlatformData?.UsedOnPlatformLumpSumAllowancePreADay}</td>
                        <NumberTextBoxEditor
                            cssWrapper="control-size-430"
                            label={UpdateLifetimeAllowanceContent.lsaOtherUsedAsAt5April2024Amount}
                            maxNumberOfDecimalPlaces={{
                                errorMessage: "Expected value to 2dp.Please re-enter",
                                value: 2,
                            }}
                            maxLength={15}
                            value={data.offPlatformData.otherUsedAsAt5April2024Amount ?? 0}
                            onChange={(v) => {
                                this.onDataChange(
                                    this.props.onChange,
                                    {
                                        otherUsedAsAt5April2024Amount: v
                                    },
                                    this.props.data,
                                    "offPlatformData"
                                );
                            }}
                            onBlur={(v) => {

                            }}
                        />
                        <NumberTextBoxEditor
                            cssWrapper="control-size-430"
                            label={UpdateLifetimeAllowanceContent.lsaOtherUsedOnOrAfter6April2024Amount}
                            maxNumberOfDecimalPlaces={{
                                errorMessage: "Expected value to 2dp.Please re-enter",
                                value: 2,
                            }}
                            maxLength={15}
                            value={data.offPlatformData.otherUsedOnOrAfter6April2024Amount ?? 0}
                            onChange={(v) => {
                                this.onDataChange(
                                    this.props.onChange,
                                    {
                                        otherUsedOnOrAfter6April2024Amount: v
                                    },
                                    this.props.data,
                                    "offPlatformData"
                                );
                            }}
                            onBlur={(v) => {

                            }}
                        />
                        {UpdateLifetimeAllowanceContent.lsdbaUsedLSDBAAsAt5April2024Amount}
                        <td className="cell-right">£{extraInfo?.onPlatformData?.UsedOnPlatformLumpSumDeathBenefitsAllowancePre2024}</td>
                        {UpdateLifetimeAllowanceContent.lsdbaUsedLSDBAOnOrAfter6April2024Amount}
                        <td className="cell-right">£{extraInfo?.onPlatformData?.UsedOnPlatformLumpSumDeathBenefitsAllowancePost2024}</td>
                        {UpdateLifetimeAllowanceContent.lsdbaUsedLSDBABefore6April2006Amount}
                        <td className="cell-right">£{extraInfo?.onPlatformData?.UsedOnPlatformLumpSumDeathBenefitsAllowancePreADay}</td>
                        <NumberTextBoxEditor
                            cssWrapper="control-size-430"
                            label={UpdateLifetimeAllowanceContent.lsdbaOtherLSDBAUsedAsAt5April2024Amount}
                            maxNumberOfDecimalPlaces={{
                                errorMessage: "Expected value to 2dp.Please re-enter",
                                value: 2,
                            }}
                            maxLength={15}
                            value={data.offPlatformData.otherLSDBAUsedAsAt5April2024Amount ?? 0}
                            onChange={(v) => {
                                this.onDataChange(
                                    this.props.onChange,
                                    {
                                        otherLSDBAUsedAsAt5April2024Amount: v
                                    },
                                    this.props.data,
                                    "offPlatformData"
                                );
                            }}
                            onBlur={(v) => {

                            }}
                        />
                        {!extraInfo?.onPlatformData?.HasNoEnhancedProtectionWithNoPCLSProtection && <RadiosEditor
                            cssWrapper="radio-group rg-150 mb-23"
                            label={UpdateLifetimeAllowanceContent.isPartOfUsedSIHBefore75}
                            selected={extraInfo?.onPlatformData?.HasSevereIllHealthDeclaration}
                            options={[true, false]}
                            getText={(v) => {
                                return v ? "Yes" : "No";
                            }}
                            onChange={(v) => {
                                this.onDataChange(
                                    this.props.onChange,
                                    {
                                        isPartOfUsedSIHBefore75: v
                                    },
                                    this.props.data,
                                    "offPlatformData"
                                );
                            }}
                        />}
                        <NumberTextBoxEditor
                            cssWrapper="control-size-430"
                            label={UpdateLifetimeAllowanceContent.lsdbaOtherLSDBAUsedOnOrAfter6April2024Amount}
                            maxNumberOfDecimalPlaces={{
                                errorMessage: "Expected value to 2dp.Please re-enter",
                                value: 2,
                            }}
                            maxLength={15}
                            value={data.offPlatformData.otherLSDBAUsedOnOrAfter6April2024Amount ?? 0}
                            onChange={(v) => {
                                this.onDataChange(
                                    this.props.onChange,
                                    {
                                        otherLSDBAUsedOnOrAfter6April2024Amount: v
                                    },
                                    this.props.data,
                                    "offPlatformData"
                                );
                            }}
                            onBlur={(v) => {

                            }}
                        />{!extraInfo?.onPlatformData?.HasNoEnhancedProtectionWithNoPCLSProtection && <RadiosEditor
                            cssWrapper="radio-group rg-150 mb-23"
                            label={UpdateLifetimeAllowanceContent.hasTakenIllHealthLumpSum}
                            selected={extraInfo?.onPlatformData?.HasSevereIllHealthDeclaration}
                            options={[true, false]}
                            getText={(v) => {
                                return v ? "Yes" : "No";
                            }}
                            onChange={(v) => {
                                this.onDataChange(
                                    this.props.onChange,
                                    {
                                        hasTakenIllHealthLumpSum: v
                                    },
                                    this.props.data,
                                    "offPlatformData"
                                );
                            }}
                        />}
                        {UpdateLifetimeAllowanceContent.allowanceUsed}
                        <td className="cell-right">£{this.GetAllowanceSum()}</td>
                    </>
                }
                {!isTYE2024Change &&
                    <>
                        <h2>{UpdateLifetimeAllowanceContent.ltaDetails}</h2>
                        <h3>
                            <b>{UpdateLifetimeAllowanceContent.ltaPreviouslyCrystallisedOnPlatform}</b>
                        </h3>
                        <td className="cell-right">{this.GetLtaPreviouslyCrystallisedOnPlatform().toFixed(2)}%</td>
                        <h3>
                            <b>{UpdateLifetimeAllowanceContent.ltaUsedByBenefitsThatCommencedPriorToDate}</b>
                        </h3>
                        <td className="cell-right">{this.GetLtaUsedByBenefitsThatCommencedPriorToDate().toFixed(2)}%</td>
                        <h3>
                            <b>{UpdateLifetimeAllowanceContent.ltaCrystallisedOffPlatform}</b>
                        </h3>
                        <div className="col-4">
                            <PercentageTextBoxEditor
                                value={
                                    this.getOffPlatformData().LifeTimeAllowanceUsedPercentage ??
                                    this.state.lifetimeAllowanceOffPlatform
                                }
                                atMost={{
                                    errorMessage: UpdateLifetimeAllowanceContent.messages.percentageOver100,
                                    value: 100,
                                }}
                                atLeast={{
                                    errorMessage: UpdateLifetimeAllowanceContent.messages.percentageUnder0,
                                    value: 0,
                                }}
                                onChange={(v) => {
                                    this.setState({ lifetimeAllowanceOffPlatform: v });
                                    this.setState({ hasLifetimeAllowanceOffPlatformChanged: true });
                                    UpdateLifetimeAllowanceAction.updateInstruction(v);
                                }}
                                required={"Please enter a percentage"}
                            />
                        </div>
                        <h3>
                            <b>{UpdateLifetimeAllowanceContent.ltaUsed} </b>
                            <span>
                                <AriaTooltip cssWrapper="is-info-icon" showCloseButton={true}>
                                    This is tested against the Standard Lifetime Allowance unless there is a protection in
                                    place.
                                </AriaTooltip>
                            </span>
                        </h3>
                        <td className="cell-right">{this.GetLtaUsed()}%</td>
                    </>
                }
            </>
        );
    }
}
